/**
 * Centralized Configuration
 * All application settings in one place with environment variable support
 */

// Server URLs
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:8000';
export const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:8000';

// WebSocket Configuration
export const WS_CONFIG = {
  // Connection
  MAX_RECONNECT_ATTEMPTS: parseInt(process.env.REACT_APP_WS_MAX_RECONNECT_ATTEMPTS || '5', 10),
  RECONNECT_INTERVAL: parseInt(process.env.REACT_APP_WS_RECONNECT_INTERVAL || '1000', 10),
  RECONNECT_MULTIPLIER: parseFloat(process.env.REACT_APP_WS_RECONNECT_MULTIPLIER || '1.5'),
  MAX_RECONNECT_DELAY: parseInt(process.env.REACT_APP_WS_MAX_RECONNECT_DELAY || '30000', 10),
  CONNECTION_TIMEOUT: parseInt(process.env.REACT_APP_WS_CONNECTION_TIMEOUT || '10000', 10),
  
  // Heartbeat
  HEARTBEAT_INTERVAL: parseInt(process.env.REACT_APP_WS_HEARTBEAT_INTERVAL || '30000', 10),
  HEARTBEAT_TIMEOUT: parseInt(process.env.REACT_APP_WS_HEARTBEAT_TIMEOUT || '45000', 10),
};

// Audio Configuration (Simple - No complex processing)
export const AUDIO_CONFIG = {
  // We send raw WAV - no conversion needed
  SEND_INTERVAL: parseInt(process.env.REACT_APP_AUDIO_SEND_INTERVAL || '1000', 10),
  MIME_TYPE: process.env.REACT_APP_AUDIO_MIME_TYPE || 'audio/webm',
};

// Environment
export const NODE_ENV = process.env.NODE_ENV || 'development';
export const IS_DEVELOPMENT = NODE_ENV === 'development';
export const IS_PRODUCTION = NODE_ENV === 'production';

// Logging
export const ENABLE_LOGS = process.env.REACT_APP_ENABLE_LOGS !== 'false';
export const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || 'info';

// Validate configuration on load
const validateConfig = () => {
  const errors = [];
  
  if (WS_CONFIG.MAX_RECONNECT_ATTEMPTS < 1) {
    errors.push('MAX_RECONNECT_ATTEMPTS must be at least 1');
  }
  
  if (WS_CONFIG.RECONNECT_INTERVAL < 100) {
    errors.push('RECONNECT_INTERVAL must be at least 100ms');
  }
  
  if (WS_CONFIG.HEARTBEAT_INTERVAL < 1000) {
    errors.push('HEARTBEAT_INTERVAL must be at least 1000ms');
  }
  
  if (errors.length > 0) {
    console.error('Configuration errors:', errors);
  }
  
  return errors.length === 0;
};

// Log configuration in development
if (IS_DEVELOPMENT && ENABLE_LOGS) {
  console.group('📋 Application Configuration');
  console.log('Server URL:', SERVER_URL);
  console.log('WebSocket URL:', WS_URL);
  console.log('WebSocket Config:', WS_CONFIG);
  console.log('Audio Config:', AUDIO_CONFIG);
  console.log('Environment:', NODE_ENV);
  
  const isValid = validateConfig();
  console.log(isValid ? '✅ Configuration valid' : '❌ Configuration has errors');
  console.groupEnd();
}

export const CALL_CONFIG = {
  HARD_RESET_ENABLED: process.env.REACT_APP_CALL_HARD_RESET === 'true',
  HARD_RESET_DELAY: parseInt(process.env.REACT_APP_CALL_HARD_RESET_DELAY || '500', 10),
};

export const USE_ULAW = false

// Export everything
const CONFIG = {
  SERVER_URL,
  WS_URL,
  WS_CONFIG,
  AUDIO_CONFIG,
  NODE_ENV,
  IS_DEVELOPMENT,
  IS_PRODUCTION,
  ENABLE_LOGS,
  LOG_LEVEL,
  CALL_CONFIG,
  USE_ULAW
};

export default CONFIG;
